const selectors = (selector, attribute = 'behaviour') => {
    const main = (thunk) => thunk(attribute, selector)

    const str = () => main(() => `[data-${attribute}="${selector}"]`)
    const node = () => document.querySelector(str())
    const nodeFrom = (el) => el.querySelector(str())
    const nodes = () => [...document.querySelectorAll(str())]
    const nodesFrom = (el) => [...el.querySelectorAll(str())]

    return {
        str,
        node,
        nodeFrom,
        nodes,
        nodesFrom,
    }
}

export const _ = (selector, attribute = 'behaviour') => {
    return selectors(selector, attribute)
}

/**
 *
 * @param {array} els - node array
 * @param {string} className - class name to toggle
 *
 */

export const toggleClasses = (els, className) => {
    els.map((el) => {
        el.classList.toggle(className)
    })
}

/**
 *
 * @param {array} els - node array
 * @param {string} className - class name to add
 *
 */

export const addClasses = (els, className) => {
    els.map((el) => {
        el.classList.add(className)
    })
}

/**
 *
 * @param {array} els - node array
 * @param {string} className - class name to add
 *
 */

export const removeClasses = (els, className) => {
    els.map((el) => {
        el.classList.remove(className)
    })
}
